/*
 * @Author: Kuaiyin FE
 * @Date: 2020-07-13 18:20:16
 * @Description: 生成闪电玩 SDK 签名链接
 * @FilePath: /vision-h5/src/lib/shandw.js
 */
import md5 from 'md5';

const APPKEY = 'b567fb71db0f446b8b2ed5395a48e16d';
const CHANNEL = '13863';
const SHANDWDOMIAN = 'http://www.shandw.com/auth/';

class ShanDW {
	constructor() {
		this._params = {};
		this._paramsToUrl = {};
		this._paramsToSign = {};
		this._signString = '';
	}
	/**
	 * @description: 初始化闪电玩
	 * @param {type}
	 * @return: void
	 */

	_init(params) {
		let { openID, nickName, avatar, sex, phone } = params;

		const time = parseInt(Date.now() / 1000);

		if (!avatar) {
			avatar = 'https://static1.kaixinyf.cn/img/cus5db6877043805813924925.png';
		}

		this._params = {
			channel: CHANNEL,
			openid: openID,
			nick: nickName,
			avatar,
			sex,
			phone,
			time,
		};

		this._paramsToUrl = {
			channel: CHANNEL,
			openid: encodeURIComponent(openID),
			nick: encodeURIComponent(nickName),
			avatar: encodeURIComponent(avatar),
			sex,
			phone,
			time,
		};

		this._paramsToSign = {
			channel: CHANNEL,
			openid: encodeURIComponent(openID),
			nick: nickName,
			avatar: avatar,
			sex,
			phone,
			time,
		};

		this._signString = `channel=${this._paramsToSign.channel}&openid=${this._paramsToSign.openid}&time=${this._paramsToSign.time}&nick=${this._paramsToSign.nick}&avatar=${this._paramsToSign.avatar}&sex=${this._paramsToSign.sex}&phone=${this._paramsToSign.phone}${APPKEY}`;

		this._sign(this._signString);
	}

	/**
	 * @description: 生成签名的方法
	 * @param {type}
	 * @return:
	 */

	_sign(signStr) {
		const sign = md5(signStr).toLowerCase();

		console.log(`sign => ${sign}`);

		this._paramsToUrl.sign = sign;
	}

	/**
	 * @description: 获取完整授权链接
	 * @param {type}
	 * @return:
	 */

	getShandwUrl(params) {
		const { sdw_simple, sdw_ld, gameID } = params;

		console.log(params);
		let resultStr = '';

		this._init(params);

		if (sdw_simple) {
			this._paramsToUrl.sdw_simple = sdw_simple;
		}

		if (sdw_ld) {
			this._paramsToUrl.sdw_ld = sdw_ld;
		}
		if (gameID) {
			this._paramsToUrl.gid = gameID;
		}

		Object.keys(this._paramsToUrl).forEach((key) => {
			resultStr += `&${key}=${this._paramsToUrl[key]}`;
		});

		console.log(resultStr);

		return `${SHANDWDOMIAN}?${resultStr.slice(1)}&initTab=freegame`;
	}
}

const shandw = new ShanDW();

export default shandw;



// WEBPACK FOOTER //
// ./src/lib/shandw.js